import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-purchase-order-list',
  templateUrl: './purchase-order-list.component.html',
  styleUrls: ['./purchase-order-list.component.css']
})
export class PurchaseOrderListComponent implements OnInit {

  public menu_item_id = '101';
  public add_auth;
  public edit_auth;

  model = {
    'table_name': 'purchase_order', 'fromDate': new Date(), 'toDate': new Date(),
    'branch_id': '0', 'purchase_order_no': '', 'order_status': '0', 'supplier_name': '', 'mobile': '', 
    'title': 'قائمة أوامر الشراء'
  };

  statusList = [{ 'status_id': '0', 'status_name': 'الكل', 'status_name_en': 'All' },
    { 'status_id': '1', 'status_name': 'فعال', 'status_name_en': 'Active' },
    { 'status_id': '2', 'status_name': 'منتهي', 'status_name_en': 'Expired' }];

  private dp = [];   
  displayedColumns = ['purchase_order_no', 'purchase_order_date', 'expiry_date', 'supplier_name', 'mobile', 
    'final_total', 'order_status', 'invoice_no', 'view', 'print', 'export_invoice'];
  displayedColumns2 = ['purchase_order_no', 'purchase_order_date', 'expiry_date', 'supplier_name', 'mobile', 
    'final_total', 'order_status', 'invoice_no'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  from_date = '';
  to_date = '';
  From_Date; To_Date; Search_Msg;
  branchList = [];

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService, private router: Router) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Search_Msg').subscribe((res: string) => {
      this.Search_Msg = res;
    });
  }


  ngOnInit() {

    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);

    this.from_date = this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) + "-" +
      this.model['fromDate'].getDate() + ' 00:00:00';
    this.to_date = this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) + "-" +
      this.model['toDate'].getDate() + ' 23:59:59';

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });

  }

  search() {
    this.dp = [];

    if ((this.model['fromDate'] == undefined || this.model['toDate'] == undefined) &&
      this.model['purchase_order_no'] == '') {
      alert(this.Search_Msg);
      return;
    }

    let obj = { cmd: 'getPurchaseList' }; 

    if (this.model['purchase_order_no'] != '') {
      obj['purchase_order_no'] = this.model['purchase_order_no'];

      if (this.branchList.length == 2) 
        obj['branch_id'] = this.branchList[1]['branch_id'];
      else {
        let branch_list = [];
        this.branchList.forEach(element => {
          if (element.branch_id != '0')
            branch_list.push({ 'branch_id': element.branch_id });
        });
        obj['branch_list'] = branch_list;
      }
    }
    else {
      if (this.model['fromDate'] != undefined) {
        this.from_date = this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) +
          "-" + this.model['fromDate'].getDate() + ' 00:00:00';
        obj['from_date'] = this.from_date;
      }

      if (this.model['toDate'] != undefined) {
        this.to_date = this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) +
          "-" + this.model['toDate'].getDate() + ' 23:59:59';
        obj['to_date'] = this.to_date;
      }

      if (this.model['order_status'] != '0')
        obj['order_status'] = this.model['order_status'];

      if (this.model['supplier_name'] != '')
        obj['supplier_name'] = this.model['supplier_name'];

      if (this.model['mobile'] != '')
        obj['mobile'] = this.model['mobile'];

      if (this.model['branch_id'] == '0') {
        if (this.branchList.length == 2) 
          obj['branch_id'] = this.branchList[1]['branch_id'];
        else {
          let branch_list = [];
          this.branchList.forEach(element => {
            if (element.branch_id != '0')
              branch_list.push({ 'branch_id': element.branch_id });
          });
          obj['branch_list'] = branch_list;
        }
      }
      else 
        obj['branch_id'] = this.model['branch_id'];
    }

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

    // this.from_date = this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) + "-" +
    //   this.model['fromDate'].getDate() + ' 00:00:00';
    // this.to_date = this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) + "-" +
    //   this.model['toDate'].getDate() + ' 23:59:59';

    // let condition = "`purchase_order_date` BETWEEN '" + this.from_date + "' AND '" + this.to_date + "' AND `status` != '0'";

    // if (this.model['branch_id'] != '0')
    //   condition += " AND `purchase_order`.`branch_id` = '" + this.model['branch_id'] + "'";

    // else if (this.model['branch_id'] == '0') {
    //   let index = 1;
    //   let list_length = this.branchList.length;

    //   condition += " AND `purchase_order`.`branch_id` IN (";
    //   this.branchList.forEach(element => {
    //     if (element.branch_id != '0') {
    //       if (index < list_length)
    //         condition += " '" + element.branch_id + "',";
    //       else if (index == list_length)
    //         condition += " '" + element.branch_id + "'";
    //     }
    //     index++;
    //   });
    //   condition += ")";
    // }

    // let query = "SELECT * FROM `purchase_order` WHERE " + condition;
    // let obj = { cmd: 'getList', query: query };

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.dp = data.data['list'];

    //     this.dp.forEach(element => {
    //       if (element.customer_no != '') {
    //         query = "SELECT `supplier_name`, `mobile` FROM `supplier` WHERE `acct_number` = '" + element.supplier_no + "'";
    //         obj = { cmd: 'getList', query: query };

    //         this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //           .subscribe(data => {
    //             this.applicationConstants.appComp.hideBusyCursor();
    //             element.supplier_name = data.data['list'][0]['supplier_name'];
    //             element.mobile = data.data['list'][0]['mobile'];
    //           });
    //       }
    //       else
    //         element.mobile = '';

    //       element.purchase_order_date = (element.purchase_order_date).substring(0, 10);
    //       element.expiry_date = (element.expiry_date).substring(0, 10);
    //       element.final_total = ((Number(element.total) + Number(element.tax) - Number(element.discount))).toFixed(2);
    //       element.order_status = element.status;
    //     });

    //     this.dataSource = new MatTableDataSource(this.dp);
    //     this.dataSource.sort = this.sort;
    //   });
  }


  print(row = null) {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    if (row == null) {
      html_data = '<table cellpadding="8" cellspacing="0"><tr>';
      html_data += '<td width="33%"> ' + this.From_Date + ': ' + this.from_date + '</td>';
      html_data += '<td width="33%"> ' + this.To_Date + ': ' + this.to_date + '</td><td width="33%"></td></tr>';
      html_data += '</table>';

      let table = (document.getElementById('order_table2') as HTMLTableElement);
      html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
    }
    else
      window.open(this.applicationConstants.generatePDF + "?type=purchase_order&no=" + row.purchase_order_no, "_blank");
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }


}
